module.exports = __webpack_public_path__ + "img/my-travelers-ico.b8229252.svg";